import { Component, OnInit, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Store } from '@ngrx/store'
import { VrboChannelService, VRBOReservationAlterationItem } from '@tokeet-frontend/channels'
import { ActionFailed } from '@tokeet-frontend/tv3-platform'
import { Toaster } from '@tokeet-frontend/tv3-platform'
import { LoadInquiryDetails, BookingAlterationChanged } from '@tv3/store/inquiry/inquiry.actions'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { EMPTY } from 'rxjs'
import { catchError, delay, finalize } from 'rxjs/operators'

@Component({
  selector: 'app-vrbo-reservation-alteration-dialog',
  templateUrl: './vrbo-reservation-alteration-dialog.component.html',
  styleUrls: ['./vrbo-reservation-alteration-dialog.component.scss'],
  host: { class: 'modal-content' },
})
export class VrboReservationAlterationDialogComponent implements OnInit {
  get alterationId() {
    return this.alteration?.['id']
  }

  get inquiry() {
    return this.data.inquiry
  }

  alteration: VRBOReservationAlterationItem

  get isHostAlteration() {
    return this.alteration?.initiated_by === 'host'
  }
  get isGuestAlteration() {
    return this.alteration?.initiated_by === 'guest'
  }

  isLoading = false
  isPending = false
  constructor(
    private store: Store<any>,
    public dialogRef: MatDialogRef<VrboReservationAlterationDialogComponent>,
    private toaster: Toaster,
    private vrboChannelService: VrboChannelService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      inquiry: Inquiry
    }
  ) {
    this.alteration = this.data.inquiry.alteration_requested as VRBOReservationAlterationItem
    this.isPending = this.alteration?.status === 'NEW'
  }

  ngOnInit(): void {}

  close() {
    this.dialogRef.close()
  }

  doAction(action: 'accept' | 'decline') {
    this.isLoading = true
    return this.vrboChannelService.updateAlteration(this.alteration.inquiry_id, action).pipe(
      finalize(() => (this.isLoading = false)),
      catchError((error) => {
        this.store.dispatch(ActionFailed({ error }))
        return EMPTY
      })
    )
  }

  onDecline() {
    this.doAction('decline').subscribe(() => {
      this.store.dispatch(LoadInquiryDetails({ id: this.inquiry.id }))
      this.store.dispatch(
        BookingAlterationChanged({ inquiryId: this.inquiry.id, alterationId: this.alterationId, source: 'vrbo' })
      )
      this.toaster.success($localize`VRBO alteration declined successfully`)
      this.close()
    })
  }

  onAccept() {
    this.doAction('accept').subscribe(() => {
      this.store.dispatch(LoadInquiryDetails({ id: this.inquiry.id }))
      this.store.dispatch(
        BookingAlterationChanged({ inquiryId: this.inquiry.id, alterationId: this.alterationId, source: 'vrbo' })
      )
      this.toaster.success($localize`VRBO alteration accepted successfully`)
      this.close()
    })
  }
}
